export default __webpack_public_path__ + "static/media/notificationIcon.18d66225.png";